
import React, { createContext, useContext, useState } from "react";

interface SearchContextType {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  isSearchOpen: boolean;
  setIsSearchOpen: (isOpen: boolean) => void;
}

const SearchContextInstance = createContext<SearchContextType | undefined>(undefined);

export function SearchContext({ children }: { children: React.ReactNode }) {
  const [searchQuery, setSearchQuery] = useState("");
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const value = {
    searchQuery,
    setSearchQuery,
    isSearchOpen,
    setIsSearchOpen,
  };

  return (
    <SearchContextInstance.Provider value={value}>
      {children}
    </SearchContextInstance.Provider>
  );
}

export function useSearch() {
  const context = useContext(SearchContextInstance);
  if (context === undefined) {
    throw new Error("useSearch must be used within a SearchProvider");
  }
  return context;
}
